// extracted by mini-css-extract-plugin
module.exports = {"paymentColumn":"PaymentPage_paymentColumn__2Vjpf","paymentContainer":"PaymentPage_paymentContainer__1l9T_"};